import styled from '@emotion/styled';
import Box from '@mui/material/Box';
import { materialTheme } from '../../../particles';

const StyledAccount = styled(Box)`
  height: 100vh;
  width: 100vw;
  overflow: hidden;
  position: relative;
  background-color: ${materialTheme.palette.primary.light};
  font-family: ${materialTheme.typography.fontFamily};

  @keyframes cardEnter {
    0% {
      opacity: 0;
      transform: translateY(8px);
    }
    100% {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @keyframes logoWrite {
    0% {
      clip-path: inset(0 100% 0 0);
    }
    100% {
      clip-path: inset(0 0 0 0);
    }
  }

  @keyframes penMove {
    0% {
      left: 0%;
      opacity: 0;
    }
    8% {
      opacity: 1;
    }
    92% {
      opacity: 1;
    }
    100% {
      left: 100%;
      opacity: 0;
    }
  }

  @keyframes penDot {
    0%,
    100% {
      transform: translate(-50%, -50%) scale(1);
      opacity: 0.9;
    }
    50% {
      transform: translate(-50%, -50%) scale(1.35);
      opacity: 1;
    }
  }

  @keyframes brandFadeIn {
    0% {
      opacity: 0;
      transform: translateY(6px);
    }
    100% {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

export default StyledAccount;
